module.exports = __webpack_public_path__ + "img/img_index_security@2x.bff2b561.png";